import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Award, FileText, CheckCircle } from 'lucide-react';
import { truncateText } from '../../lib/utils';

export const EBookCard = ({ ebook }) => {
  const {
    ebook_id,
    title,
    description,
    cpd_points,
    category,
    thumbnail_url,
    has_quiz,
  } = ebook;

  const defaultThumbnail = "https://images.unsplash.com/photo-1772588627474-ae6acc69ac42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxjb21wbGlhbmNlJTIwZG9jdW1lbnR8ZW58MHx8fHwxNzc0NDQ4NjUzfDA&ixlib=rb-4.1.0&q=85";

  return (
    <Link 
      to={`/ebooks/${ebook_id}`}
      className="group relative bg-navigate-surface border border-zinc-800 rounded-xl overflow-hidden hover:border-navigate-gold/50 transition-all duration-300 hover:-translate-y-1 block"
      data-testid={`ebook-card-${ebook_id}`}
    >
      {/* Image */}
      <div className="aspect-[3/4] w-full overflow-hidden bg-zinc-800 relative">
        <img 
          src={thumbnail_url || defaultThumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        
        {/* Book icon overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-14 h-14 rounded-full bg-navigate-gold flex items-center justify-center">
            <BookOpen className="h-6 w-6 text-black" />
          </div>
        </div>

        {/* Has Quiz Badge */}
        {has_quiz && (
          <div className="absolute top-3 right-3 bg-green-500/90 text-white px-2 py-1 rounded text-xs font-medium flex items-center gap-1">
            <CheckCircle className="h-3 w-3" />
            Quiz
          </div>
        )}

        {/* CPD Badge */}
        {cpd_points > 0 && (
          <div className="absolute top-3 left-3 bg-navigate-gold text-black px-2 py-1 rounded text-xs font-bold flex items-center gap-1">
            <Award className="h-3 w-3" />
            {cpd_points} CPD
          </div>
        )}

        {/* Title on image */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <span className="text-xs text-navigate-gold font-medium uppercase tracking-wider">
            {category}
          </span>
          <h3 className="font-heading font-semibold text-white text-lg mt-1 line-clamp-2">
            {title}
          </h3>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <p className="text-xs text-zinc-400 line-clamp-2 mb-3">
          {truncateText(description, 80)}
        </p>
        
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1 text-xs text-zinc-500">
            <FileText className="h-3 w-3" />
            PDF
          </div>
          <span className="text-sm text-navigate-gold font-medium group-hover:translate-x-1 transition-transform">
            Read →
          </span>
        </div>
      </div>
    </Link>
  );
};

export default EBookCard;
